import React, { useEffect, useState } from "react";
import axios from "axios";
import dayjs from "dayjs";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { Spin, Table, Button } from "antd";

import { handleError } from "../../modules/presence/sagas";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 20px;
`;

const baseapi = process.env.REACT_APP_API + "/api";
const setVisitStatusToToProcess = async (visitId, token) => {
  try {
    await axios.put(
      `${baseapi}/nextgen/rest/v1/call/${visitId}?Status=toProcess`,
      {},
      {
        headers: {
          Authorization: token
        }
      }
    );
  } catch (e) {
    handleError(e);
  }
};
const setAllMissingVisitsStatusToToProcess = async token => {
  try {
    await axios.post(
      `${baseapi}/nextgen/rest/v1/calls/setMissingToProcess`,
      {},
      {
        headers: {
          Authorization: token
        }
      }
    );
  } catch (e) {
    handleError(e);
  }
};

const NextGenVisitsMissing = ({ token }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);

  const fetchMissingVisits = async () => {
    setIsLoading(true);
    try {
      const result = await axios.get(`${baseapi}/nextgen/missingvisits`, {
        headers: {
          Authorization: token
        }
      });
      setData(result.data);
    } catch (e) {
      handleError(e);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    fetchMissingVisits();
  }, []);
  const columns = [
    { title: "visit_id", dataIndex: "_id", key: "_id" },

    {
      title: "Utilisateur",
      key: "user_fullName",
      sortable: true,
      render: (text, record, index) => {
        return <div>{record.user_fullName}</div>;
      }
    },
    {
      title: "Secteur",
      key: "sector_label",
      sortable: true,
      render: (text, record, index) => {
        return <div>{record.sector_label}</div>;
      }
    },
    {
      title: "PDC",
      key: "pdc_label",
      sortable: true,
      render: (text, record, index) => {
        return <div>{record.pdc_label}</div>;
      }
    },

    {
      title: "PDC ID",
      key: "pdc_id",
      sortable: true,
      render: (text, record, index) => {
        return <div>{record.pdc_id}</div>;
      }
    },
    {
      title: "Date",
      key: "Day",
      sortable: true,
      render: (text, record, index) => {
        return <div>{dayjs(record.startDate).format("DD/MM/YY")}</div>;
      }
    },
    {
      title: "Actions",
      key: "actions",
      sortable: false,
      render: (text, record, index) => {
        return (
          <div style={{ minHeight: 36, paddingTop: 11 }}>
            <Link
              to={{
                pathname: `/visit/preview/${record._id}`
              }}
            >
              Voir la visite
            </Link>
            <div
              className={`cursor-pointer underline text-orange-400 pr-10 mt-5`}
              onClick={async () => {
                setIsLoading(true);
                await setVisitStatusToToProcess(record._id, token);
                await fetchMissingVisits();
                setIsLoading(false);
              }}
            >
              Réinitialiser le statut de la visite
            </div>
          </div>
        );
      }
    }
  ];
  return (
    <Container>
      <HeaderContainer>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
          <div style={{ fontSize: 30 }}>{`Liste des visites détectées comme manquantes`}</div>
        </div>
        <Button
          disabled={isLoading}
          className="p-content-page-center-header-buttons-item"
          style={{ background: "#52c41a" }}
          onClick={async () => {
            setIsLoading(true);
            await setAllMissingVisitsStatusToToProcess(token);
            await fetchMissingVisits();
            setIsLoading(false);
          }}
        >
          Réinitialiser le statut de toutes les visites manquantes
        </Button>
      </HeaderContainer>
      <React.Fragment>
        {isLoading ? (
          <Spin />
        ) : (
          <Table rowKey="_id" columns={columns} dataSource={data} pagination={false} align="center" />
        )}
      </React.Fragment>
    </Container>
  );
};

export default NextGenVisitsMissing;



// WEBPACK FOOTER //
// src/pages/NextGenDashboard/NextGenVisitsMissing.js